export default "__VITE_ASSET__640a978d__"